function Validator() {
    return {
        validateEmail: function (value) {
            var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return re.test(String(value).toLowerCase());
        },

        validatePhone: function (value) {
            var re = /^[0-9]{10,11}$/;
            return re.test(String(value).toLowerCase());
        },

        validateNumber: function (value) {
            var re = /^\d+$/;
            return re.test(String(value).toLowerCase());
        },

        verify: function (value, rule) {
            if (value == undefined || value == null) {
                value = "";
            }
            console.log(rule);
            if (typeof rule == "string") {
                console.log("instanse of string");
                var rules = rule.split("|");
                console.log(rules);
                for (var i = 0; i < rules.length; i++) {
                    console.log(rules[i]);
                    switch (rules[i]) {
                        case "required":
                            if (value.trim().length == 0) {
                                return {
                                    validate: false,
                                    description: "required"
                                };
                            }
                            break;
                        case "email":
                            if (!this.validateEmail(value)) {
                                return {
                                    validate: false,
                                    description: "email format"
                                };
                            }
                            break;
                        case "phone":
                            if (!this.validatePhone(value)) {
                                return {
                                    validate: false,
                                    description: "phone format"
                                };
                            }
                            break;
                        case "number":
                            if (!this.validateNumber(value)) {
                                return {
                                    validate: false,
                                    description: "number format"
                                };
                            }
                            break;
                        case "min":
                            return {
                                validate: true
                            }
                            break;
                        case "max":
                            return {
                                validate: true
                            }
                            break;
                    }
                }
            } else {
                console.log("not instanse of string");

            }

            return {
                validate: true
            }

        },

        validate: function (vueItem) {
            var validate = true;
            let firstError = true;
            console.log(vueItem.$refs.input);
            if(vueItem.$refs.input == undefined || vueItem.$refs.input == null || vueItem.$refs.input == []){
                return true;
            }
            vueItem.$refs.input.forEach((item) => {
                console.log(item);
                if(item.validate == undefined || item.validate == null){
                    return;
                } else {
                    if (item.type == "text") {
                        if (item.text != undefined && item.text != null) {
                            item.text = item.text.trim();
                        }
                    }
                    let result = this.verify(item.$vnode.data.model.value, item.validate);
                    if (!result.validate) {
                        item.error = true;
                        item.errorMessage = [item.label + " " + result.description];
                        if (firstError) {
                            firstError = false;
                            item.focus();
                        }
                        validate = false;
                    }
                }
            });
            return validate;
        }
    };
};

export default Validator;